import uniq from 'lodash/uniq';
import without from 'lodash/without';
import difference from 'lodash/difference';
import {
  RECEIVED_FILTERED_REPORTS,
  FETCH_FILTERED_REPORTS_REQUEST,
  SELECT_SINGLE_REPORT,
  DESELECT_SINGLE_REPORT,
  SELECT_ALL_REPORTS,
  DESELECT_ALL_REPORTS,
} from './actionTypes';
import { t } from '../reportsManager';
// import type { ReportsTableObject } from './types';

const initialReportTableState = {
  data: [],
  total: 15,
  openReportsTableModal: false,
  tableConfig: {
    page: 1,
    pageSize: 10,
    orderBy: 'id',
    sortDesc: true,
    sorting: 'descending',
    filter: '',
  },
  selectedReports: [],
  isLoading: false,
};

const reportsTableReducer = (state = initialReportTableState, action) => {
  switch (action.type) {
    case RECEIVED_FILTERED_REPORTS:
      return {
        ...state,
        total: action.total,
        data: action.reports.map((r) => r.id),
        isLoading: false,
      };
    case FETCH_FILTERED_REPORTS_REQUEST:
      return {
        ...state,
        tableConfig: action.filters,
        isLoading: true,
      };
    case t.OPEN_DELETE_REPORT_MODAL:
      return {
        ...state,
        openReportsTableModal: true,
        deleteReportId: action.deleteReportId,
      };
    case t.CLOSE_DELETE_REPORT_MODAL:
      return {
        ...state,
        openReportsTableModal: false,
      };
    case SELECT_SINGLE_REPORT:
      return {
        ...state,
        selectedReports: [...state.selectedReports, action.id],
      };
    case DESELECT_SINGLE_REPORT: {
      return {
        ...state,
        selectedReports: without(state.selectedReports, action.id),
      };
    }
    case t.DELETE_REPORTS_RESPONSE: {
      return {
        ...state,
        selectedReports: [],
      };
    }
    case t.OPEN_BULK_DELETE_REPORT_MODAL: {
      return {
        ...state,
        openReportsTableModal: true,
        reportIds: action.reportIds,
      };
    }
    case t.CLOSE_BULK_DELETE_REPORT_MODAL: {
      return {
        ...state,
        openReportsTableModal: false,
      };
    }
    case SELECT_ALL_REPORTS: {
      return {
        ...state,
        selectedReports: uniq([
          // Already selected reportIds
          ...state.selectedReports,
          // Newly selected reportIds
          ...state.data,
        ]),
      };
    }
    case DESELECT_ALL_REPORTS: {
      return {
        ...state,
        selectedReports: uniq(difference(state.selectedReports, state.data)),
      };
    }
    default: {
      return state;
    }
  }
};

export default reportsTableReducer;
